import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderSlot as _renderSlot, createTextVNode as _createTextVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = { class: "modal__main" }
const _hoisted_3 = { class: "modal__title line line--b" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "modal__content" }
const _hoisted_6 = { class: "modal__btns line line--t" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "loading"
}

import { Teleport } from 'vue';

interface Props{
    modelValue: boolean,
    content: any,
    title: string,
    close: boolean,
    maskClose?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'modal',
  props: {
    modelValue: { type: Boolean, default: false },
    content: { default: '' },
    title: { default: '' },
    close: { type: Boolean, default: true },
    maskClose: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'update:modelValue', modalValue: boolean) : void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, content: any, title: string, close: boolean, maskClose: boolean }




let loading = false;

const handleCancel = () => {
    emits('update:modelValue', false);
};

const handleConfirm = () => {
    emits('update:modelValue', false);
};

const t = (name:string) => {
    if(name === 'r.cancel') {
        return '取消';
    } else if(name === 'r.confirm'){
        return '确定';
    } else {
        return '关闭';
    }
}


return (_ctx: any,_cache: any) => {
  const _component_Content = _resolveComponent("Content")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "mask",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.maskClose && !_unref(loading) && handleCancel()))
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", null, _toDisplayString(__props.title || t("r.title")), 1),
              (__props.close)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    title: t('r.close'),
                    class: "close",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (!_unref(loading) && handleCancel()))
                  }, "✕", 8, _hoisted_4))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (typeof __props.content === 'function')
                ? (_openBlock(), _createBlock(_component_Content, {
                    key: 0,
                    render: __props.content
                  }, null, 8, ["render"]))
                : _renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
                    _createTextVNode(_toDisplayString(__props.content), 1)
                  ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                disabled: _unref(loading),
                onClick: handleConfirm
              }, [
                (_unref(loading))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, " ❍ "))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(t("r.confirm")), 1)
              ], 8, _hoisted_7),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (!_unref(loading) && handleCancel()))
              }, _toDisplayString(t("r.cancel")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})